import * as React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import API from "../../helpers/apiHelpers";
import { Autocomplete } from "@material-ui/lab";
import { TextField, Typography, Button} from "@material-ui/core";
import {useEffect} from "react";
import {useHistory} from "react-router-dom";

const SearchPetParent: React.FC = () => {
    const [profiles, setProfiles] = React.useState<undefined | any>([]);
    const [user, setUser] = React.useState<undefined | any>();
    const [query, setQuery] = React.useState("");
    const [queryName, setQueryName] = React.useState("");
    const history = useHistory();
    const [emailKey, setEmailKey] = React.useState(100);
    const [nameKey, setNameKey] = React.useState(1);

    const getProfiles = async (email, name) => {
        try {
            if (email) {
                const profileList = await API.getProfiles({type: "OWNER", email: email});
                setProfiles(profileList);
            }
            else {
                const profileList = await API.getProfiles({type: "OWNER", name: name});
                setProfiles(profileList);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        if (query.length) {
            const timeOutId = setTimeout(() => getProfiles(query, null), 500);
            return () => clearTimeout(timeOutId);
        }
    }, [query]);

    useEffect(() => {
        if (queryName.length) {
            const timeOutId = setTimeout(() => getProfiles(null, queryName), 500);
            return () => clearTimeout(timeOutId);
        }
    }, [queryName]);


    const handleSubmit = async () => {
        if (user) {
            history.push({pathname: "/petParentProfile", state: {
                PetParentId: user.userId,
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
                phone: user.phoneNumber}});
        }
    };

    return(
        <Card style={{padding: 10, marginTop: 20, maxWidth: 800}}>
            <CardContent>
                <Typography variant="h3" style={{marginBottom: 20}}>
                    Pet parent search
                </Typography>
            </CardContent>
            <CardContent>
                <Typography gutterBottom>
                    Select pet parent email from the dropdown:
                </Typography>
                <Autocomplete
                    key={emailKey}
                    id="userProfile"
                    value={user}
                    onChange={(event, value) => {
                        setUser(value);
                        setNameKey(nameKey+1);
                    }}
                    options={profiles}
                    style={{marginBottom: 20}}
                    getOptionLabel={(option) => option.email}
                    renderInput={(params) => <TextField {...params} variant="outlined" onChange={(event) => setQuery(event.target.value)} />}
                />
                <Typography gutterBottom>
                    Select pet parent name from the dropdown:
                </Typography>
                <Autocomplete
                    id="userProfile"
                    key={nameKey}
                    value={user}
                    onChange={(event, value) => {
                        setUser(value);
                        setEmailKey(emailKey+1);
                    }}
                    options={profiles}
                    style={{marginBottom: 20}}
                    getOptionLabel={(option) => option.firstName + " " + option.lastName}
                    renderInput={(params) => <TextField {...params} variant="outlined" onChange={(event) => setQueryName(event.target.value)} />}
                />
                <Button
                    variant="contained"
                    onClick={() => {
                        handleSubmit();
                    }}
                    color="primary"
                    style={{margin: "30px auto 0", width: 100, display: "block"}}
                >
                    Search
                </Button>

            </CardContent>
        </Card>
    );
};

export default SearchPetParent;
